var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "open-page" },
    [
      _c("childNav", {
        attrs: { routerName: _vm.$t("breadcrumbItem.data"), backFlag: true },
      }),
      _c("div", { staticClass: "open-body" }, [
        _c(
          "div",
          { staticClass: "open-box" },
          [
            _c(
              "Form",
              {
                ref: "addForm",
                attrs: {
                  "label-width": _vm.enFlag ? 200 : 130,
                  model: _vm.addForm,
                  "label-colon": "",
                  rules: _vm.ruleValidate,
                },
              },
              [
                _c(
                  "FormItem",
                  {
                    attrs: {
                      label: _vm.$t("openConfig.version"),
                      prop: "version",
                    },
                  },
                  [
                    _c(
                      "Select",
                      {
                        staticClass: "select-width",
                        attrs: {
                          size: "large",
                          clearable: "",
                          placeholder: _vm.$t("openConfig.versionTip"),
                        },
                        model: {
                          value: _vm.addForm.version,
                          callback: function ($$v) {
                            _vm.$set(_vm.addForm, "version", $$v)
                          },
                          expression: "addForm.version",
                        },
                      },
                      _vm._l(_vm.versionList, function (item, index) {
                        return _c(
                          "Option",
                          { key: index, attrs: { value: item } },
                          [_vm._v(_vm._s(item))]
                        )
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "FormItem",
                  {
                    attrs: {
                      label: _vm.$t("openConfig.signType"),
                      prop: "signType",
                    },
                  },
                  [
                    _c(
                      "RadioGroup",
                      {
                        model: {
                          value: _vm.addForm.signType,
                          callback: function ($$v) {
                            _vm.$set(_vm.addForm, "signType", $$v)
                          },
                          expression: "addForm.signType",
                        },
                      },
                      _vm._l(_vm.signList, function (item, index) {
                        return _c(
                          "Radio",
                          {
                            key: index,
                            attrs: { label: item.value, size: "large" },
                          },
                          [_c("span", [_vm._v(_vm._s(item.label))])]
                        )
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "FormItem",
                  { attrs: { label: _vm.$t("openConfig.fileLabel") } },
                  [
                    _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                      _c("span", { staticClass: "error-color" }, [_vm._v("*")]),
                      _vm._v(
                        " " + _vm._s(_vm.$t("openConfig.fileLabel")) + " "
                      ),
                    ]),
                    _c("form", { attrs: { id: "uploadImg" } }, [
                      _c(
                        "div",
                        { staticClass: "form-box" },
                        [
                          _c(
                            "Button",
                            {
                              staticClass: "file upload-btn",
                              attrs: { type: "primary" },
                            },
                            [
                              _c("Icon", {
                                staticClass: "add-icon",
                                attrs: { type: "md-add" },
                              }),
                              _vm._v(
                                " " + _vm._s(_vm.$t("openConfig.addFile")) + " "
                              ),
                              _c("input", {
                                attrs: {
                                  type: "file",
                                  name: "facePic",
                                  multiple: "",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.showPic($event)
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]),
                  ]
                ),
                _vm.hasList
                  ? _c(
                      "div",
                      [
                        _c("Table", {
                          attrs: {
                            columns: _vm.columns12,
                            stripe: "",
                            border: "",
                            "tooltip-theme": "light",
                            data: _vm.dataList,
                            height: "360",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "confType",
                                fn: function (ref) {
                                  var row = ref.row
                                  var index = ref.index
                                  return [
                                    _c(
                                      "RadioGroup",
                                      {
                                        on: {
                                          "on-change": function ($event) {
                                            return _vm.changeConf(row, index)
                                          },
                                        },
                                        model: {
                                          value: row.confType,
                                          callback: function ($$v) {
                                            _vm.$set(row, "confType", $$v)
                                          },
                                          expression: "row.confType",
                                        },
                                      },
                                      _vm._l(
                                        _vm.confList,
                                        function (item, index) {
                                          return _c(
                                            "Radio",
                                            {
                                              key: index,
                                              staticClass: "radio-margin",
                                              attrs: { label: item.value },
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(_vm._s(item.label)),
                                              ]),
                                            ]
                                          )
                                        }
                                      ),
                                      1
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "zipType",
                                fn: function (ref) {
                                  var row = ref.row
                                  var index = ref.index
                                  return [
                                    _c(
                                      "RadioGroup",
                                      {
                                        on: {
                                          "on-change": function ($event) {
                                            return _vm.changeZip(row, index)
                                          },
                                        },
                                        model: {
                                          value: row.zipType,
                                          callback: function ($$v) {
                                            _vm.$set(row, "zipType", $$v)
                                          },
                                          expression: "row.zipType",
                                        },
                                      },
                                      _vm._l(
                                        _vm.zipList,
                                        function (item, index) {
                                          return _c(
                                            "Radio",
                                            {
                                              key: index,
                                              staticClass: "radio-margin",
                                              attrs: { label: item.value },
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(_vm._s(item.label)),
                                              ]),
                                            ]
                                          )
                                        }
                                      ),
                                      1
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "action",
                                fn: function (ref) {
                                  var row = ref.row
                                  var index = ref.index
                                  return [
                                    _c(
                                      "Button",
                                      {
                                        attrs: { type: "error" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.delFile(index)
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.$t("common.delete")))]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            877399980
                          ),
                        }),
                      ],
                      1
                    )
                  : _c(
                      "div",
                      {
                        staticClass: "noList-box",
                        class: { "red-border": _vm.checkFile },
                      },
                      [
                        _c("img", {
                          staticClass: "img-table",
                          attrs: {
                            src: require("../../assets/image/nodata-icon.png"),
                          },
                        }),
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("openConfig.noFile"))),
                        ]),
                      ]
                    ),
                _vm.checkFile
                  ? _c("span", { staticClass: "require-tip" }, [
                      _vm._v(_vm._s(_vm.$t("openConfig.checkFile"))),
                    ])
                  : _vm._e(),
                !_vm.checkFile
                  ? _c("div", { staticClass: "tip-height" })
                  : _vm._e(),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "bottom-btn" },
              [
                _c(
                  "Button",
                  {
                    staticClass: "btn-width",
                    attrs: { ghost: "", size: "large", type: "primary" },
                    on: { click: _vm.resetForm },
                  },
                  [_vm._v(_vm._s(_vm.$t("openConfig.reset")))]
                ),
                _c(
                  "Button",
                  {
                    staticClass: "btn-width",
                    attrs: {
                      size: "large",
                      type: "primary",
                      loading: _vm.loading,
                    },
                    on: { click: _vm.submitForm },
                  },
                  [_vm._v(_vm._s(_vm.$t("openConfig.pack")))]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "content_win" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }